



























































































































































































































































































































/** @format */
import {
  // @Component
  Vue,
  Component,
  Watch,
  Prop
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import Utils from '@/utils/common';
// axios请求
import { addOrEditDeviceList, editInfoDeviceList, deviceInfo } from '@/api/parking-lot-management/index';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { DEVICE_LIST } from '../../router-names';
// 导入字典
import {
  dictAlonePayMap,
  dictDeviceTypeMap,
  dictDeviceConnectionMap,
  dictUnitTypeMap
} from '@/types/parking-lot-management/dictionaries';
import * as _ from 'lodash';
// form表单项定义
export interface IForm {
  parkId: String; //所属车场
  name: String; //	设备名称
  deviceCode: String; //	设备名称
  type: String; //	设备类型( 00:摄像机 01:道闸 02:语音 03:显示屏 04:车位诱导设备 05 车位引导屏 09其他)
  brand: String; //	设备品牌 01海康 02大华 03文通 04臻识 05华夏 06立方 07立林 08科拓 09富士 10欧冠 11真地
  ip: String; //	ip地址
  mode: String; //	设备型号
  // deviceStatus: String //	设备状态 01：正常 00：异常
  isSupportTts: String; //	是否支持万能语音 00:否 01::
  // status: String //	使用状态  01：正常  00：失效
  port: String; //设备端口
  connectSource: String; //设备连接源
  connectType: String; //设备连接方式  01：透传 02:RJ45 03:Internit网络通信 04: RS485 ,485通信
  deviceVersion: String; //驱动版本号  海康相机 1000001 大华相机1000031 文通相机 1000061  臻识相机 1000091 华夏相机 1000121 立方相机 1000151 立林相机 1000181 科拓相机 1000211 富士相机 1000241 欧冠LED屏 2000001 真地LED屏 2000031 立方LED屏 2000061 文通LED屏 2000091 立林LED屏 2000021 欧冠道闸 3000001 自定义协议测试相机 4294967294 不存在的类型 4294967295
  priority: String; //	设备优先级
}
import { isShiDaill } from '@/utils/env';
@Component({
  components: { ParkingLotSearch }
})
// @Component
export default class AddEditDevice extends Vue {
  @Prop()
  dataForm!: any;

  @Prop()
  parkId!: string;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop({ type: Boolean, default: false })
  isParkdisabled!: boolean;

  // @Prop({ type: Number, default: '' })
  // deviceLength!: Number

  isvisible: boolean = true;
  form: any = null;
  validatorsTrim = trim;
  deviceId: string = '';
  deviceOptions: any[] = []; // 设备名称
  deviceCode: string = ''; // 设备编号
  type: any = '';
  brand: any = '';
  isWenLv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //查看图片文旅定制化
  //判断是否是时代邻里
  isShiDaill: boolean = isShiDaill;
  // 是否支持万能语音 00:否 01 是
  isSupportTtsTypeOptions: IOption[] = Utils.toLabelVal(dictAlonePayMap);
  //判断是否存在并push
  judgeIs(list: any[], id: string) {
    const index = list.findIndex(item => item.value == id);
    if (index > -1) {
      list.unshift(list[index]);
    }
  }
  spining: boolean = false;
  // 设备品牌 01海康 02大华 03文通 04臻识 05华夏 06立方 07立林 08科拓 09富士 10欧冠 11真地
  @Getter('dictionaries/deviceBrand')
  deviceBrandMap?: any;
  get brandOptions(): any[] {
    return Utils.toLabelVal(this.deviceBrandMap);
  }

  @Getter('dictionaries/allDictionaries')
  allDictionaries?: any;
  //根据设备类型获取设备品牌
  get typeBrandOptions(): any[] {
    const typeBrandArr = Utils.toLabelVal(this.allDictionaries[`device_type_${this.type}`] || {});
    if (!this.isWenLv) {
      if (this.type == '01') {
        this.judgeIs(typeBrandArr, '01');
        this.judgeIs(typeBrandArr, '13');
        this.judgeIs(typeBrandArr, '04');
        this.judgeIs(typeBrandArr, '05');
      }
      if (this.type == '02') {
        this.judgeIs(typeBrandArr, '15');
        this.judgeIs(typeBrandArr, '07');
        this.judgeIs(typeBrandArr, '14');
        this.judgeIs(typeBrandArr, '17');
        this.judgeIs(typeBrandArr, '10');
        this.judgeIs(typeBrandArr, '12');
      }
      if (this.type == '09') {
        this.judgeIs(typeBrandArr, '17');
      }
    }
    return _.uniq(typeBrandArr) || [];
  }
  //根据设备品牌获取设备驱动和设备型号
  get brandModeOptions(): any[] {
    const brandModeArr = Utils.toLabelVal(this.allDictionaries[`device_type_${this.type}_${this.brand}`] || {});
    return brandModeArr.sort(Utils.compare('value')) || [];
  }

  // 设备类型下拉框
  @Getter('dictionaries/deviceType')
  deviceTypeMap?: object;
  get typeOptions(): any[] {
    const typeArr = Utils.toLabelVal(this.deviceTypeMap || {});
    if (!this.isWenLv) {
      this.judgeIs(typeArr, '08');
      this.judgeIs(typeArr, '12');
      this.judgeIs(typeArr, '10');
      this.judgeIs(typeArr, '09');
      this.judgeIs(typeArr, '03');
      this.judgeIs(typeArr, '02');
      this.judgeIs(typeArr, '01');
      console.log('设备类型==》', _.uniq(typeArr));
    }
    return _.uniq(typeArr);
    // return typeArr.sort(Utils.compare('value')) || []
  }
  // typeOptions: IOption[] = Utils.toLabelVal(dictDeviceTypeMap)
  // 设备连接方式  01：透传 02:RJ45 03:Internit网络通信 04: RS485 ,485通信
  @Getter('dictionaries/deviceConnectType')
  deviceConnectTypeMap?: any;
  get deviceConnectionOptions(): any[] {
    return Utils.toLabelVal(this.deviceConnectTypeMap);
  }
  @Getter('dictionaries/deviceVersion')
  deviceVersionMap?: any;
  get driverNumOptions(): any[] {
    return Utils.toLabelVal(this.deviceVersionMap);
  }
  // driverNumOptions: IOption[] = Utils.toLabelVal(dictDriverNumMap)
  // 设备型号
  @Getter('dictionaries/deviceMode')
  deviceModeMap?: any;
  get unitTypeOptions(): any[] {
    return Utils.toLabelVal(this.deviceModeMap);
  }
  // unitTypeOptions: IOption[] = Utils.toLabelVal(dictUnitTypeMap)

  //设备连接源
  @Getter('dictionaries/deviceConnectSource')
  deviceConnectSourceMap?: any;
  get deviceConnectOptions(): any[] {
    return Utils.toLabelVal(this.deviceConnectSourceMap);
  }

  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.init();
  }

  get isParkDisabled() {
    return this.isParkdisabled;
  }
  // 生命周期初始化
  created() {
    this.deviceId = this.$route.params.deviceId;
    this.init();
  }

  private handleCancel() {
    this.form.resetFields();
    // this.$router.replace({
    //   name: DEVICE_LIST,
    // })
    this.$emit('cancel');
  }

  // 初始化form表单
  init() {
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            parkId,
            name, //	设备名称
            deviceCode, //	设备名称
            type, //	设备类型( 00:摄像机 01:道闸 02:语音 03:显示屏 04:车位诱导设备 05 车位引导屏 09其他)
            brand, //	设备品牌 01海康 02大华 03文通 04臻识 05华夏 06立方 07立林 08科拓 09富士 10欧冠 11真地
            ip, //	ip地址
            mode, //	设备型号
            isSupportTts, //	是否支持万能语音 00:否 01::
            port, //设备端口
            connectSource, //设备连接源
            connectType, //设备连接方式  01：透传 02:RJ45 03:Internit网络通信 04: RS485 ,485通信
            deviceVersion, //驱动版本号  海康相机 1000001 大华相机1000031 文通相机 1000061  臻识相机 1000091 华夏相机 1000121 立方相机 1000151 立林相机 1000181 科拓相机 1000211 富士相机 1000241 欧冠LED屏 2000001 真地LED屏 2000031 立方LED屏 2000061 文通LED屏 2000091 立林LED屏 2000021 欧冠道闸 3000001 自定义协议测试相机 4294967294 不存在的类型 4294967295
            priority, //	设备优先级
            terminalName //所属终端
          } = this.dataForm;
          this.type = type;
          this.brand = brand;
          return {
            parkId: this.$form.createFormField({
              value: parkId
            }),
            name: this.$form.createFormField({
              value: name
            }),
            deviceCode: this.$form.createFormField({
              value: deviceCode
            }),
            type: this.$form.createFormField({
              value: type
            }),
            brand: this.$form.createFormField({
              value: brand
            }),
            ip: this.$form.createFormField({
              value: ip
            }),
            mode: this.$form.createFormField({
              value: mode
            }),
            isSupportTts: this.$form.createFormField({
              value: isSupportTts
            }),
            port: this.$form.createFormField({
              value: port
            }),
            connectSource: this.$form.createFormField({
              value: connectSource
            }),
            connectType: this.$form.createFormField({
              value: connectType
            }),
            deviceVersion: this.$form.createFormField({
              value: deviceVersion
            }),
            priority: this.$form.createFormField({
              value: priority
            }),
            terminalName: this.$form.createFormField({
              value: terminalName
            })
          };
        }
      });
    } else {
      let result = [];
      if (this.typeOptions) {
        result = _.filter(this.typeOptions, function(o) {
          return o.value == '01';
        });
      }
      const defaultType = this.typeOptions[0] ? this.typeOptions[0].value || '' : '';
      this.type = defaultType;
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            // 新增车场步骤进来，parkId自动带入表单
            parkId: this.$form.createFormField({
              value: this.isParkDisabled ? this.parkId : ''
            }),
            //默认选中第一个
            type: this.$form.createFormField({
              value: this.type
            }),
            connectType: this.$form.createFormField({
              value: this.deviceConnectionOptions[0] ? this.deviceConnectionOptions[0].value || '' : ''
            }),
            connectSource: this.$form.createFormField({
              value: this.deviceConnectOptions[0] ? this.deviceConnectOptions[0].value || '' : ''
            })
          };
        }
      });
      this.$nextTick(() => {
        if (this.type) {
          this.getType(this.type);
        }
      });
    }
  }

  // 提交
  async handleSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (this.spining) return;
        this.spining = true;
        this.onAddOrEdit(values);
      }
    });
  }
  async onAddOrEdit(values: IForm) {
    // TIP: 和后端沟通接口返回ID给前端
    try {
      const { data: deviceId = '' } = await addOrEditDeviceList({
        ...values,
        // 编辑状态id从dataForm中获取，否则为空
        ...(this.isEdit ? { deviceId: this.dataForm.deviceId } : {}),
        // isParkdisabled为true，车场id不可以修改外部带入
        ...(this.isParkDisabled ? { parkId: this.parkId } : {}),
        iotId: this.iotId ? this.iotId : ''
      });
      const { data } = await editInfoDeviceList({ deviceId });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      // 提交成功保存返回ID，再添加列表的编辑功能中有用
      this.$emit('ok', {
        ...data, // 用保存接口返回的id查询出的信息内容，补足编辑内容中的中文展示
        ...values, // 当前编辑内容
        deviceId
      });
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.spining = false;
    }
  }
  //获取设备类型id
  getType(val: any) {
    this.type = val;
    this.form.setFieldsValue({
      brand: '',
      mode: '',
      deviceVersion: ''
    });
    if (this.typeBrandOptions.length > 0) {
      this.form.setFieldsValue({
        brand: this.typeBrandOptions[0].value
      });
      this.brand = this.typeBrandOptions[0].value;
      if (!this.isWenLv) {
        this.changeBrandto();
      }
      if (this.brandModeOptions.length > 0) {
        this.form.setFieldsValue({
          mode: this.brandModeOptions[0].value,
          deviceVersion: this.brandModeOptions[0].value
        });
      }
    }
  }
  //品牌联动改动点
  changeBrandto() {
    console.log('这里的type', this.type);
    console.log('这里的brand', this.brand);
    this.form.setFieldsValue({
      port: '',
      isSupportTts: '01'
    });
    //车牌识别相机
    if (this.type == '01') {
      this.form.setFieldsValue({
        connectType: '02'
      });
      //海康 RJ45 8000
      if (this.brand == '01') {
        this.form.setFieldsValue({
          port: '8000'
        });
      }
      //大华
      if (this.brand == '02') {
        this.form.setFieldsValue({
          port: '37777'
        });
      }
      //ZS HX LL
      if (this.brand == '04' || this.brand == '05' || this.brand == '07') {
        this.form.setFieldsValue({
          port: '80'
        });
      }
      //科拓
      if (this.brand == '08') {
        this.form.setFieldsValue({
          port: '5001'
        });
      }
      //QY
      if (this.brand == '13') {
        this.form.setFieldsValue({
          port: '30000'
        });
      }
      //蓝卡
      if (this.brand == '15') {
        this.form.setFieldsValue({
          port: ''
        });
      }
    }
    //LED
    if (this.type == '02') {
      // this.form.setFieldsValue({
      //   isSupportTts: '01',
      // })
      //欧冠
      if (this.brand == '10') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '5000',
          isSupportTts: '00'
        });
      }
      //威视
      if (this.brand == '12') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '8800'
        });
      }
      //LL
      if (this.brand == '07') {
        this.form.setFieldsValue({
          connectType: '04',
          port: ''
        });
      }
      if (this.brand == '07') {
        this.form.setFieldsValue({
          connectType: '04',
          port: ''
        });
      }
      //德亚
      if (this.brand == '16') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '8800'
        });
      }
      //HRZX
      if (this.brand == '17') {
        this.form.setFieldsValue({
          connectType: '04',
          port: ''
        });
      }
      //AK
      if (this.brand == '14') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '11036'
        });
      }
      //KT
      if (this.brand == '08') {
        this.form.setFieldsValue({
          connectType: '04',
          port: ''
        });
      }
      //LK
      if (this.brand == '15') {
        this.form.setFieldsValue({
          connectType: '04',
          port: ''
        });
      }
    }
    //道闸
    if (this.type == '03') {
      this.form.setFieldsValue({
        connectType: '01'
      });
      //JS
      if (this.brand == '23') {
        this.form.setFieldsValue({
          port: ''
        });
      }
      //DY
      if (this.brand == '16') {
        this.form.setFieldsValue({
          port: '',
          connectType: '02'
        });
      }
      // 威捷
      if (this.brand == '18') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '5000'
        });
      }
      //LK
      if (this.brand == '15') {
        this.form.setFieldsValue({
          port: ''
        });
      }
    }
    //机器人
    if (this.type == '09') {
      //hrzx  //XA //ql
      if (this.brand == '17' || this.brand == '19' || this.brand == '20') {
        this.form.setFieldsValue({
          connectType: '02',
          port: ''
        });
      }
    }
    //etc
    if (this.type == '10') {
      //ST
      if (this.brand == '22') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '21003'
        });
      }
    }
    //IO监控
    if (this.type == '13') {
      //HY
      if (this.brand == '21') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '1000'
        });
      }
    }
    //扫码器
    if (this.type == '08') {
      //WS
      if (this.brand == '12') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '8849'
        });
      }
    }
    //道闸遥控器
    if (this.type == '12') {
      //道闸遥控器
      if (this.brand == '21') {
        this.form.setFieldsValue({
          connectType: '02',
          port: '1000'
        });
      }
    }
  }
  //获取连接方式
  getConnectType(val: any) {
    console.log('链接方式', val);
    //RJ485
    // if (val == '04') {
    //   if (this.brand == '10') {
    //     this.form.setFieldsValue({
    //       port: '',
    //       isSupportTts: '00',
    //     })
    //   }
    //   if (this.brand == '17') {
    //     this.form.setFieldsValue({
    //       port: '',
    //       isSupportTts: '01',
    //     })
    //   }
    // }
  }
  //获取设备版本id
  getBrand(val: any) {
    this.brand = val;
    if (!this.isWenLv) {
      this.changeBrandto();
    }
    this.form.setFieldsValue({
      mode: '',
      deviceVersion: ''
    });
    if (this.brandModeOptions.length > 0) {
      this.form.setFieldsValue({
        mode: this.brandModeOptions[0].value,
        deviceVersion: this.brandModeOptions[0].value
      });
    }
  }
  // 获取设备列表
  async getDeviceInfo(value: string) {
    try {
      const res = await deviceInfo({
        currPage: 1,
        pageSize: 100,
        deviceName: value
      });
      const deviceOptions = res.data.records.map(item => {
        return {
          value: `${item.deviceName}/${item.deviceTypeName}`,
          label: `${item.deviceName}/${item.deviceTypeName}`,
          code: item.deviceCode
        };
      });
      this.deviceOptions = deviceOptions;
    } catch (error) {
      console.log(error);
    }
  }
  timer: any = null;
  // 设备名称模糊匹配，间隔1s调用接口
  changeDeviceName(e: any) {
    let i = 0;
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => {
      i++;
      if (i === 10) {
        this.getDeviceInfo(e.target.value);
        clearInterval(this.timer);
      }
    }, 100);
  }
  iotId: string = '';
  // 设备名称选择后设备编号联动
  selectDeviceName(val: string) {
    if (val) {
      let deviceCode = '';
      this.deviceOptions.forEach(item => {
        if (item.value === val) {
          deviceCode = item.code;
          this.iotId = item.iotId;
        }
      });
      this.form.setFieldsValue({
        deviceCode: deviceCode
      });
    } else {
      this.deviceOptions = [];
      this.form.setFieldsValue({
        deviceCode: ''
      });
    }
  }
}
